import { SecondaryButton } from 'components/theme/Button/Button';
import React from 'react';
import styled, { css } from 'styled-components';

interface OverflowOptionButtonProps {
  isActive: boolean;
  /** Sizes the button as a fixed-width time chip instead of the default option button. */
  isTimeChip?: boolean;
  label: string;
  onSelect: (value: string) => void;
  testId: string;
  value: string;
}

/**
 * One choice in the grid. It owns the click so the group can hand every button the same callback
 * rather than closing over each option's value in the loop.
 */
const OverflowOptionButton = ({
  isActive,
  isTimeChip = false,
  label,
  onSelect,
  testId,
  value,
}: OverflowOptionButtonProps) => {
  const handleClick = () => {
    if (!isActive) {
      onSelect(value);
    }
  };

  const Button = isTimeChip ? TimeChipButton : OptionButton;

  return (
    <Button
      data-testid={testId}
      className={`session-button-active-${isActive} continuous-session-picker__option`}
      selected={isActive}
      onClick={handleClick}
    >
      {label}
    </Button>
  );
};

const OptionButton = styled(SecondaryButton)`
  padding: 8px 8px;
`;

const TimeChipButton = styled(SecondaryButton)`
  align-items: center;
  display: flex;
  flex-direction: column;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  gap: 12px;
  height: auto;
  letter-spacing: 0.014px;
  line-height: normal;
  padding: 8px 8px;
  text-align: center;
  /* A time reads on one line: "9:00 AM" must not wrap its AM or PM underneath. */
  white-space: nowrap;
  width: 80px;

  ${({ selected }) =>
    !selected &&
    css`
      color: var(--way-colors-contrastColorShades-80);
    `}
`;

export default OverflowOptionButton;
